import script from "./LoginLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginLayout.vue?vue&type=script&setup=true&lang=js"

import "./LoginLayout.vue?vue&type=style&index=0&id=25e73c7c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25e73c7c"]])

export default __exports__